import { isStaffUser } from '../../../../utils/user'

// The inhabitant's building/flat must be fetched to auto-complete the address
// only for a selected non-staff user that has no property info yet and whose
// address is not already driven by a contract.
export function shouldFetchInhabitantPropertyInfo({
  contractValue,
  selectedUser,
}) {
  return (
    !!selectedUser &&
    !isStaffUser(selectedUser) &&
    !selectedUser.propertyInfo &&
    !contractValue
  )
}
